import React from "react";
import { useI18n } from "@/i18n";
import Seo from "@/components/Seo";
import { Kicker, PageHero, Section, CardGrid } from "@/components/Primitives";

export default function Projects() {
  const { t } = useI18n();
  return (
    <div data-testid="projects-page">
      <Seo pageKey="projects" />
      <PageHero kicker={t("projects.kicker")} title={t("projects.title")} lead={t("projects.lead")} />

      <Section>
        <p className="max-w-3xl text-base leading-relaxed text-foreground/90 sm:text-lg">{t("projects.p1")}</p>
        <div className="mt-16">
          <Kicker>{t("projects.typesKicker")}</Kicker>
          <CardGrid items={t("projects.types")} testIdPrefix="project-type" />
        </div>
      </Section>

      <Section className="bg-primary text-primary-foreground">
        <Kicker className="text-primary-foreground/60">{t("projects.processKicker")}</Kicker>
        <ol data-testid="project-process" className="mt-10 grid grid-cols-1 gap-px bg-primary-foreground/15 sm:grid-cols-2 lg:grid-cols-4">
          {t("projects.process").map((step, index) => (
            <li key={step.title} className="bg-primary p-8">
              <span className="font-display text-3xl text-accent">{String(index + 1).padStart(2, "0")}</span>
              <h3 className="mt-4 font-display text-xl">{step.title}</h3>
              <p className="mt-2 text-sm text-primary-foreground/75">{step.body}</p>
            </li>
          ))}
        </ol>
      </Section>
    </div>
  );
}
